import { IDealForDrawdownStoreItem } from '../distribution/deals/interfaces';

type DealId = string;
export enum FetchingDealsForDrawdownStatus {
  Loading = 'loading',
  Succeeded = 'succeeded',
  Failed = 'failed',
  Idle = 'idle'
}

export enum SavingDrawdownStatus {
  Saving = 'saving',
  Succeeded = 'succeeded',
  Failed = 'failed',
  Idle = 'idle'
}

export enum DeleteDrawdownStatus {
  Deleting = 'deleting',
  Succeeded = 'succeeded',
  Failed = 'failed',
  Idle = 'idle'
}

export interface IDrawdownState {
  loading: boolean;
  selectedDrawDownId: string | null;
  drawdown: IDrawdownDealItemStore | null;
  dealsForDrawdownMap: Record<DealId, IDealForDrawdownStoreItem>;
  idsOfDealsForDrawdownList: DealId[];
  fetchingDealsForDrawdownStatus: FetchingDealsForDrawdownStatus;
  savingDrawdownStatus: SavingDrawdownStatus;
  deleteDrawdownStatus: DeleteDrawdownStatus;
}

export enum DealType {
  ProjectServices = 'SERVICES_PROJECT'
}

export interface IDealLineItemResponse {
  description: string;
  quantity: number;
  price: number;
  amount: number;
}

export enum DealStateResponse {
  Pending = 'PENDING',
  Final = 'FINAL'
}

export interface IDealResponse {
  id: string;
  name: string;
  type: DealType;
  closeDate: string;
  contacts: string;
  contactSxIds: string[];
  amount: number;
  lineItems: IDealLineItemResponse[];
}

export interface IDrawdownDealResponse {
  _id: string;
  projectId?: string;
  drawdownAmount: number;
  deal: IDealResponse;
  status?: DealStateResponse;
}

export interface IDealLineItemStore extends Omit<IDealLineItemResponse, 'price' | 'amount'>{
  priceInCents: number;
  lineTotalInCents: number;
}

export enum DrawdownStatus {
  Pending = 'PENDING',
  Final = 'FINAL'
}
export interface IDealStore extends Omit<IDealResponse, 'lineItems' | 'amount' | 'state'>{
  lineItems: IDealLineItemStore[];
  totalDealAmountInCents: number;
  status: DrawdownStatus | null;

}
export interface IDrawdownDealItemStore {
  id: string;
  projectId?: string;
  amountInCents: number;
  deal: IDealStore;
}

interface IUpsertDrawdownPayload {
  creditPoolId: string;
  dealId: string;
  drawdownId: string | undefined;
}

export interface IUpsertPendingDrawdownPayload extends IUpsertDrawdownPayload {
  projectId: string | undefined;
  projectName?: string;
}

export interface IUpsertFinalizedPendingDrawdownPayload extends IUpsertDrawdownPayload {
  projectId: string;
  projectName: string;
}

export interface IDeleteDrawdownPayload {
  creditPoolId: string;
  dealId: string;
}
